module.exports = __webpack_public_path__ + "src/img/cut.cba6b5e7.svg";